import styles from "./clickdropdown.module.scss";
import React, { useEffect, useState } from 'react';
import { Menu, Dropdown, Form, DatePicker, Checkbox } from 'antd';
import { Radio } from 'antd';
//*import PropTypes from 'prop-types';
//*import { URCheckBox } from './checkbox';
import { RRule } from 'rrule';
import moment from "moment";
type eventState = {
  isRecurringEvent: boolean;
  recurrence: string;
  repeat_every: number;
  value_disabled: number;
  afteroccur: number;
  byEnddate: Date;
  occurMonthday: number;
  occureon: number;
  monthlyWeek: string;
  monthlyDay: string;
  weeklyOccuron: Array<any>;
  checkBoxVal: Array<any>;
}
type chatProps = {
  recur: any;
  updateState: (state: any) => void;
}
export default function ClickDropdown({ recur, updateState }: chatProps) {
  var day = new Date();
  const [eventInfo, setEventInfo] = useState<eventState>
    ({
      isRecurringEvent: false, recurrence: "", repeat_every: 1, value_disabled: 1, afteroccur: 0, checkBoxVal: [],
      byEnddate: new Date(), occurMonthday: day.getDate(), occureon: 3, monthlyWeek: "First", monthlyDay: "Sun", weeklyOccuron: []
    });
  //*const { Option } = Select;
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  useEffect(() => {
    if (recur && recur?.rrule !== undefined) {
      let editRRule: any = recur?.rrule !== undefined ? new RRule(RRule.parseString(recur.rrule)) : "";
      let bynweekday = editRRule.options.bynweekday || [];
      var end_date = new Date(parseFloat(recur.dtend) * 1000);
      let monthlyweekNo = bynweekday?.length > 0 ? bynweekday[0][1] === -1 ? 'First' : bynweekday[0][1] === -2 ? 'Second' :
        bynweekday[0][1] === -3 ? 'Third' : bynweekday[0][1] === -4 ? 'Fourth' : 'Last' : 'First';
      let bynmonthlyDay = bynweekday?.length > 0 ? days[bynweekday[0][0]] : 'Sun';

      let tempDays: any = [];
      let byweekday: any = editRRule.options.byweekday || [];
      byweekday.forEach((item: any) => {
        tempDays.push(days[item]);
      });

      setEventInfo({
        ...eventInfo, recurrence: recur.recurOptions, byEnddate: end_date,
        monthlyWeek: monthlyweekNo, monthlyDay: bynmonthlyDay,
        checkBoxVal: byweekday, weeklyOccuron: tempDays, repeat_every: editRRule.options.interval,
        afteroccur: editRRule.options?.count > 0 ? editRRule.options?.count : 0,
        value_disabled: editRRule.options?.count > 0 ? 2 : 1
      });
    }
  }, [recur]);

  const selectOption = (e: any) => {
    var start_date = new Date(parseFloat(recur.dtstart) * 1000);
    let endday = e.key === "Weekly" ? 7 : e.key === "Monthly" ? 30 : 0;
    var someDate = new Date(start_date);
    var result = someDate.setDate(someDate.getDate() + endday);
    var end = new Date(result);
    end.setHours(23, 59, 59, 999);

    setEventInfo({ ...eventInfo, recurrence: e.key, byEnddate: new Date(result), repeat_every: 1 });
    eventInfo['recurrence'] = e.key;
    eventInfo['byEnddate'] = end;
    eventInfo['repeat_every'] = 1;
    updateState(eventInfo);


  };
  const selectRepeat = (e: any) => {
    var start_date = new Date(parseFloat(recur.dtstart) * 1000);
    let endday = eventInfo.recurrence === "Weekly" ? 7 : eventInfo.recurrence === "Monthly" ? 30 : 1;
    var someDate = new Date(start_date);
    var result = someDate.setDate(someDate.getDate() + (e.key * endday));
    setEventInfo({ ...eventInfo, byEnddate: new Date(result), repeat_every: e.key });
    eventInfo['repeat_every'] = e.key;
    eventInfo['byEnddate'] = new Date(result);
    updateState(eventInfo);
  };
  const selectAfterOccur = (e: any) => {
    setEventInfo({ ...eventInfo, afteroccur: e.key });
    eventInfo['afteroccur'] = parseInt(e.key);
    updateState(eventInfo);
  };
  const disabledDate = (from: any, current: any) => {
    return new Date(from.setDate(from.getDate())) >= current;
  };
  const selectOccurMonth = (e: any) => {
    setEventInfo({ ...eventInfo, occurMonthday: e.key });
    eventInfo['occurMonthday'] = parseInt(e.key);
    updateState(eventInfo);

  };
  const selectMonthWeek = (e: any) => {
    setEventInfo({ ...eventInfo, monthlyWeek: e.key });
    eventInfo['monthlyWeek'] = e.key;
    updateState(eventInfo);
  };
  const selectMonthDay = (e: any) => {
    setEventInfo({ ...eventInfo, monthlyDay: e.key });
    eventInfo['monthlyDay'] = e.key;
    updateState(eventInfo);
  };

  let selectRepeatOpt: any = ['1', '2', '3', '4'];
  let allday: any = Array.from(Array(30).keys());
  let monthlyWeekSelect: any = ['First', 'Second', 'Third', 'Fourth', 'Last'];
  let monthDaysSelect: any = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const menu = (
    <Menu onClick={selectOption}>
      <Menu.Item key={'None'}>None</Menu.Item>
      <Menu.Item key={'Daily'}>Daily</Menu.Item>
      <Menu.Item key={'Weekly'}>Weekly</Menu.Item>
      <Menu.Item key={'Monthly'}>Monthly</Menu.Item>
    </Menu>
  );

  const menu2 = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={selectRepeat}>
      {selectRepeatOpt.map((list: any) => <Menu.Item key={list}>{list}</Menu.Item>)}
    </Menu>
  );

  const menu3 = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={selectOccurMonth}>
      {allday.map((list: any) => <Menu.Item key={list}>{list}</Menu.Item>)}
    </Menu>
  );

  const numbers = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={selectMonthWeek}>{
      monthlyWeekSelect.map((list: any) => <Menu.Item key={list}>{list}</Menu.Item>)
    }
    </Menu>
  );

  const month = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={selectMonthDay}>
      {monthDaysSelect.map((list: any) => <Menu.Item key={list.substring(0, 3)}>{list}</Menu.Item>)}
    </Menu>
  );

  const menu5 = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={selectAfterOccur}>
      {selectRepeatOpt.map((list: any) => <Menu.Item key={list}>{list}</Menu.Item>)}
    </Menu>
  );

  const radioChecked = (e: any) => {
    setEventInfo({ ...eventInfo, value_disabled: e.target.value });
    if (e.target.value === 1) {
      eventInfo['afteroccur'] = 0
      updateState(eventInfo);
      setEventInfo({ ...eventInfo, afteroccur: 0, value_disabled: e.target.value });
    }
  };
  const occursChecked = (e: any) => {
    setEventInfo({ ...eventInfo, occureon: e.target.value });
    if (e.target.value === 4) {
      eventInfo['occureon'] = e.target.value;
      updateState(eventInfo);
    }
  };
  const handleDateChange = (value: any, dateString: any) => {
    setEventInfo({ ...eventInfo, byEnddate: value });
    if (value) {
      eventInfo['byEnddate'] = value;
      updateState(eventInfo);
    }
  };
  const updateMultiCheckbox = (event: any, index: number) => {
    var isChecked = event.target.checked;
    if (isChecked) {
      let { checkBoxVal } = eventInfo;
      checkBoxVal.push(index);
      setEventInfo({
        ...eventInfo, weeklyOccuron: [...eventInfo.weeklyOccuron, event.target.value],
        checkBoxVal: checkBoxVal
      });
      eventInfo['weeklyOccuron'] = [...eventInfo.weeklyOccuron, event.target.value];
      updateState(eventInfo);

    } else {
      const index = eventInfo.weeklyOccuron.indexOf(event.target.value);
      eventInfo.weeklyOccuron.splice(index, 1);
      let { checkBoxVal } = eventInfo;
      checkBoxVal.splice(index, 1);
      setEventInfo({ ...eventInfo, weeklyOccuron: eventInfo.weeklyOccuron, checkBoxVal: checkBoxVal });
      let { weeklyOccuron } = eventInfo;
      eventInfo['weeklyOccuron'] = weeklyOccuron;
      updateState(eventInfo);
    }
  };


  return (
    <>
      <div className={styles.dropdownsection}>

        <div className={styles.recurrence}>
          Recurrence
          <Dropdown overlay={menu} placement="bottomCenter" ><h3>{eventInfo.recurrence}
            <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
        </div>
        {eventInfo.recurrence !== "None" && <div className={`${styles.repeat} monthlythree`}>
          Repeat Every
          <Dropdown overlay={menu2} placement="bottomCenter"><h3>{eventInfo.repeat_every}
            <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}>
            </span></h3></Dropdown><span className={styles.days}>
            {eventInfo.recurrence === "Weekly" ? "Week" : eventInfo.recurrence === "Monthly" ? "Month" : "Day"}</span>
        </div>}


        {eventInfo.recurrence === "Monthly" &&
          <Radio.Group onChange={(e) => occursChecked(e)} value={eventInfo.occureon}>
            <div className={`${styles.repeatselectdiv} monthlyone`}>
              Occurs on
              <Radio value={3} className={styles.occureon}>Day
                <div className={`timefield ${styles.dropdownsec}`}>
                  <Dropdown overlay={menu3} placement="bottomCenter"><h3>{eventInfo.occurMonthday}
                    <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}>
                    </span></h3></Dropdown><span className={` ${styles.days}`}>Of the month</span>
                </div>
              </Radio>
            </div>

            <div className={`${styles.monthselectsection} monthlytwo`}>
              <div className={styles.afterselect}>
                <Radio value={4}> After
                  <div className={styles.two}>
                    <Dropdown disabled={eventInfo.occureon === 4 ? false : true} overlay={numbers} placement="bottomCenter"><h3>{eventInfo.monthlyWeek}
                      <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
                    <Dropdown disabled={eventInfo.occureon === 4 ? false : true} overlay={month} placement="bottomCenter"><h3>{eventInfo.monthlyDay}
                      <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}>
                      </span></h3></Dropdown><span className={`${styles.days} ofmonth`}>Of the month</span>
                  </div>
                </Radio>
              </div>
            </div>
          </Radio.Group>}


        {eventInfo.recurrence !== "None" &&
          <div className={styles.eventradiobutton}>
            <div className={`afternew ${styles.repeatselectdiv}`}>
              <Form.Item className="dropdownlist">
                <Radio.Group onChange={(e) => radioChecked(e)} value={eventInfo.value_disabled}>
                  <Radio value={1}>
                    <div className={styles.checkboxRow}>
                      <span className={styles.checkLabel}>By end date</span>
                      <DatePicker className="customDatepicker"
                        format={'DD/MM/YYYY'}
                        value={eventInfo.byEnddate !== null ? moment(eventInfo.byEnddate) : null}
                        disabledDate={(e) => disabledDate(new Date(), e)}
                        dropdownClassName='datepickerDropdown' placeholder='End date'
                        disabled={eventInfo.value_disabled === 1 ? false : true} onChange={handleDateChange} />
                    </div>
                  </Radio>

                  <Radio value={2} className={` ${styles.occureon} ${styles.after}`}>After
                    <div className={`${styles.checkboxRow} ${styles.dropdownsec}`}>
                      <Dropdown overlay={menu5} placement="bottomCenter"
                        disabled={eventInfo.value_disabled === 2 ? false : true}><h3>{eventInfo.afteroccur}
                          {/* <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span> */}
                        </h3></Dropdown><span className={styles.days}>Occurrence(s)</span>
                    </div>
                  </Radio>

                </Radio.Group>
              </Form.Item>
            </div>
          </div>}
        {eventInfo.recurrence === "Weekly" && <div className={styles.occursWeekly}>
          <span className={styles.lableOn}>Occurs on</span>
          <div className={`${styles.multicheck}`}>
            {days.map((item: any, index: any) => (
              <Checkbox key={index} onChange={(e) => updateMultiCheckbox(e, index)} value={item}
                checked={eventInfo.checkBoxVal.indexOf(index) !== -1}>{item}</Checkbox>
            ))}

          </div>
        </div>}

      </div>
    </>
  );
};
